import React from "react";
import {
  Box,
  Skeleton,
  Card,
} from "@mui/material";

const ActiveOrderSkeleton = () => {
  return (
    <Box sx={{ p: 2, mt: 7 }}>
      {/* Company Info */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Box>
          <Skeleton width={180} height={30} />
          <Skeleton width={250} height={20} />
        </Box>

        <Skeleton
          variant="circular"
          width={70}
          height={70}
        />
      </Box>

      {/* Product Summary */}
      <Skeleton
        variant="rounded"
        height={60}
        sx={{ borderRadius: 3, mb: 3 }}
      />

      {/* Order Id */}
      <Box mb={3}>
        <Skeleton width={250} height={30} />
        <Skeleton width={130} height={20} />
      </Box>

      {/* Product Cards */}
      {[1, 2, 3].map((item) => (
        <Card
          key={item}
          sx={{
            p: 2,
            mb: 2,
            borderRadius: "18px",
            boxShadow: "none",
            border: "1px solid rgba(56,79,111,0.08)",
          }}
        >
          <Box display="flex">
            <Skeleton
              variant="rounded"
              width={70}
              height={70}
            />

            <Box flex={1} ml={2}>
              <Skeleton width="75%" height={30} />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Skeleton width={80} height={25} />
                <Skeleton width={60} height={25} />
              </Box>
            </Box>
          </Box>
        </Card>
      ))}

      {/* Grand Total */}
      <Card
        sx={{
          p: 2,
          mb: 3,
          borderRadius: "16px",
          boxShadow: "none",
          border: "1px solid rgba(56,79,111,0.08)",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
        >
          <Skeleton width={120} height={30} />
          <Skeleton width={90} height={30} />
        </Box>
      </Card>

      {/* Buttons */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
        }}
      >
        <Skeleton
          variant="rounded"
          width="50%"
          height={50}
          sx={{ borderRadius: "10px" }}
        />
        <Skeleton
          variant="rounded"
          width="50%"
          height={50}
          sx={{ borderRadius: "10px" }}
        />
      </Box>
    </Box>
  );
};

export default ActiveOrderSkeleton;